import PropTypes from "prop-types";
import styles from "./PassportAdminReviewerItem.module.css";
import classNames from 'classnames';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCheck,
} from "@fortawesome/free-solid-svg-icons";

export default function PassportAdminReviewerItem({ info, onView, width }) {
  return (
    <div className={styles.reviewItemRow}>
      <div className={classNames(styles.col)} style={{ width: `${width.nameWidth}px` }}>
        <a className={styles.link} onClick={onView}>{info.name}</a>
      </div>
      <div className={classNames(styles.col)} style={{ width: `${width.statusWidth}px` }}>
        {info.reviewStatus || ""}
      </div>
      <div className={classNames(styles.col)} style={{ width: `${width.verifiedWidth}px` }}>
        {info.VerificationComplete ? (
          <div className={styles.iconCenter}>
            <span data-tooltip-id={`my-tooltip`} data-tooltip-type={info.VerifiedByType}>
              <FontAwesomeIcon
                icon={faCheck}
                style={{
                  color: "green",
                  fontSize: "20px",
                }}
              />
            </span>
          </div>
        ) : (
          ""
        )}
      </div>
      <div className={classNames(styles.col)} style={{ width: `${width.programWidth}px` }}>
        {info.program}
      </div>
      <div className={classNames(styles.col)} style={{ width: `${width.schoolWidth}px` }}>
        {info.school}
      </div>
      <div className={classNames(styles.col)} style={{ width: `${width.idWidth}px` }}>
        {info.sid}
      </div>

      <div className={classNames(styles.col, styles.textCenter)} style={{ width: `${width.viewWidth}px` }}>
        <button className={styles.button} onClick={onView}>VIEW</button>
      </div>
    </div>
  );
};

PassportAdminReviewerItem.propTypes = {
  info: PropTypes.shape({
    name: PropTypes.string,
    sid: PropTypes.string,
    school: PropTypes.string,
    program: PropTypes.string,
    status: PropTypes.string,
    reviewStatus: PropTypes.string,
    VerificationComplete: PropTypes.bool,
  }).isRequired,
};